/**
 * Exam Registry
 * All state exams available in the simulator.
 * Every entry here has backend skill data (state_exams.json).
 */

// State images — Unsplash photos loosely related to each state
const STATE_IMAGES = {
  AK: 'https://images.unsplash.com/photo-1503095396549-807759245b35?w=400&h=225&fit=crop&q=80',
  AL: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=225&fit=crop&q=80',
  AR: 'https://images.unsplash.com/photo-1614267157481-ca66efc399a0?w=400&h=225&fit=crop&q=80',
  AZ: 'https://images.unsplash.com/photo-1474044159687-1ee9f3a51722?w=400&h=225&fit=crop&q=80',
  CA: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=400&h=225&fit=crop&q=80',
  CO: 'https://images.unsplash.com/photo-1546156929-a4c0ac411f47?w=400&h=225&fit=crop&q=80',
  CT: 'https://images.unsplash.com/photo-1601980743883-ca7c5de4cfa5?w=400&h=225&fit=crop&q=80',
  DC: 'https://images.unsplash.com/photo-1501466044931-62695aada8e9?w=400&h=225&fit=crop&q=80',
  DE: 'https://images.unsplash.com/photo-1555424681-b0ecf4fe19a5?w=400&h=225&fit=crop&q=80',
  FL: 'https://images.unsplash.com/photo-1605723517503-3cadb5818a0c?w=400&h=225&fit=crop&q=80',
  GA: 'https://images.unsplash.com/photo-1587351021759-3e566b6af7cc?w=400&h=225&fit=crop&q=80',
  HI: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=225&fit=crop&q=80',
  IA: 'https://images.unsplash.com/photo-1625244724120-1fd1d34d00f6?w=400&h=225&fit=crop&q=80',
  ID: 'https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5?w=400&h=225&fit=crop&q=80',
  IL: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=400&h=225&fit=crop&q=80',
  IN: 'https://images.unsplash.com/photo-1569517904426-a22a3c079f2e?w=400&h=225&fit=crop&q=80',
  KS: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=225&fit=crop&q=80',
  KY: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=400&h=225&fit=crop&q=80',
  LA: 'https://images.unsplash.com/photo-1568402102990-bc541580b59f?w=400&h=225&fit=crop&q=80',
  MA: 'https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=400&h=225&fit=crop&q=80',
  MD: 'https://images.unsplash.com/photo-1569761316261-9a8696fa2ca3?w=400&h=225&fit=crop&q=80',
  ME: 'https://images.unsplash.com/photo-1506197603052-3cc9c3a201bd?w=400&h=225&fit=crop&q=80',
  MI: 'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=400&h=225&fit=crop&q=80',
  MN: 'https://images.unsplash.com/photo-1558459654-c430be5b0891?w=400&h=225&fit=crop&q=80',
  MO: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=400&h=225&fit=crop&q=80',
  MS: 'https://images.unsplash.com/photo-1571941316689-a98c91920da4?w=400&h=225&fit=crop&q=80',
  MT: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=225&fit=crop&q=80',
  NC: 'https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=400&h=225&fit=crop&q=80',
  ND: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=400&h=225&fit=crop&q=80',
  NE: 'https://images.unsplash.com/photo-1504701954957-2010ec3bcec1?w=400&h=225&fit=crop&q=80',
  NH: 'https://images.unsplash.com/photo-1605106901227-991bd663255c?w=400&h=225&fit=crop&q=80',
  NJ: 'https://images.unsplash.com/photo-1500916434205-0c77489c6cf7?w=400&h=225&fit=crop&q=80',
  NM: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=400&h=225&fit=crop&q=80',
  NV: 'https://images.unsplash.com/photo-1581351721010-8cf859cb14a4?w=400&h=225&fit=crop&q=80',
  NY: 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=400&h=225&fit=crop&q=80',
  OH: 'https://images.unsplash.com/photo-1548971379-fa4b93cff258?w=400&h=225&fit=crop&q=80',
  OK: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=400&h=225&fit=crop&q=80',
  OR: 'https://images.unsplash.com/photo-1508193638397-1c4234db14d8?w=400&h=225&fit=crop&q=80',
  PA: 'https://images.unsplash.com/photo-1555109307-f7d9da25c244?w=400&h=225&fit=crop&q=80',
  RI: 'https://images.unsplash.com/photo-1494548162494-384bba4ab999?w=400&h=225&fit=crop&q=80',
  SC: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=225&fit=crop&q=80',
  SD: 'https://images.unsplash.com/photo-1472396961693-142e6e269027?w=400&h=225&fit=crop&q=80',
  TN: 'https://images.unsplash.com/photo-1545419913-94e4fd068ebf?w=400&h=225&fit=crop&q=80',
  TX: 'https://images.unsplash.com/photo-1531218150217-54595bc2b934?w=400&h=225&fit=crop&q=80',
  UT: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=400&h=225&fit=crop&q=80',
  VA: 'https://images.unsplash.com/photo-1553969420-fb915228af30?w=400&h=225&fit=crop&q=80',
  VI: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=225&fit=crop&q=80',
  VT: 'https://images.unsplash.com/photo-1605106901227-991bd663255c?w=400&h=225&fit=crop&q=80',
  WA: 'https://images.unsplash.com/photo-1542223189-67a03fa0f0bd?w=400&h=225&fit=crop&q=80',
  WI: 'https://images.unsplash.com/photo-1558459654-c430be5b0891?w=400&h=225&fit=crop&q=80',
  WV: 'https://images.unsplash.com/photo-1508193638397-1c4234db14d8?w=400&h=225&fit=crop&q=80',
  WY: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=225&fit=crop&q=80',
  GUAM: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=225&fit=crop&q=80',
  MARIANA: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=225&fit=crop&q=80',
};

const STATE_NAMES = {
  AK: 'Alaska', AL: 'Alabama', AR: 'Arkansas', AZ: 'Arizona', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DC: 'District of Columbia', DE: 'Delaware',
  FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', IA: 'Iowa', ID: 'Idaho',
  IL: 'Illinois', IN: 'Indiana', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana',
  MA: 'Massachusetts', MD: 'Maryland', ME: 'Maine', MI: 'Michigan', MN: 'Minnesota',
  MO: 'Missouri', MS: 'Mississippi', MT: 'Montana', NC: 'North Carolina',
  ND: 'North Dakota', NE: 'Nebraska', NH: 'New Hampshire', NJ: 'New Jersey',
  NM: 'New Mexico', NV: 'Nevada', NY: 'New York', OH: 'Ohio', OK: 'Oklahoma',
  OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
  SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VA: 'Virginia',
  VI: 'Virgin Islands', VT: 'Vermont', WA: 'Washington', WI: 'Wisconsin',
  WV: 'West Virginia', WY: 'Wyoming',
  GUAM: 'Guam', MARIANA: 'Northern Mariana Islands',
};

function makeExamEntry(stateCode, provider, overrides = {}) {
  const stateName = STATE_NAMES[stateCode] || stateCode;
  const providerLabel = provider.charAt(0).toUpperCase() + provider.slice(1);
  const id = stateCode.length <= 2
    ? `${stateName.toLowerCase().replace(/\s+/g, '-')}-${provider}`
    : `${stateCode.toLowerCase()}-${provider}`;

  return {
    id,
    state: stateName,
    stateCode,
    provider,
    providerLabel,
    examName: `${stateName} CNA Skills Evaluation (${providerLabel})`,
    skillsPerExam: 5,
    totalTimeMinutes: 45,
    image: STATE_IMAGES[stateCode] || STATE_IMAGES.GA,
    passingScore: 70,
    unlocked: true,
    completedCount: 0,
    bestScore: null,
    ...overrides,
  };
}

export const EXAM_REGISTRY = [
  // ═══ CREDENTIA STATES (17) ═══
  makeExamEntry('GA', 'credentia'),
  makeExamEntry('AK', 'credentia'),
  makeExamEntry('AL', 'credentia'),
  makeExamEntry('CA', 'credentia'),
  makeExamEntry('CO', 'credentia'),
  makeExamEntry('DC', 'credentia'),
  makeExamEntry('MD', 'credentia'),
  makeExamEntry('NC', 'credentia'),
  makeExamEntry('NV', 'credentia'),
  makeExamEntry('PA', 'credentia'),
  makeExamEntry('RI', 'credentia'),
  makeExamEntry('SC', 'credentia'),
  makeExamEntry('VA', 'credentia'),
  makeExamEntry('WA', 'credentia'),
  makeExamEntry('VI', 'credentia'),
  makeExamEntry('GUAM', 'credentia'),
  makeExamEntry('MARIANA', 'credentia'),

  // ═══ HEADMASTER STATES (19) ═══
  makeExamEntry('MA', 'headmaster'),
  makeExamEntry('AR', 'headmaster'),
  makeExamEntry('AZ', 'headmaster'),
  makeExamEntry('CA', 'headmaster'),
  makeExamEntry('KY', 'headmaster'),
  makeExamEntry('MI', 'headmaster'),
  makeExamEntry('MN', 'headmaster'),
  makeExamEntry('MO', 'headmaster'),
  makeExamEntry('MS', 'headmaster'),
  makeExamEntry('MT', 'headmaster'),
  makeExamEntry('ND', 'headmaster'),
  makeExamEntry('NM', 'headmaster'),
  makeExamEntry('OH', 'headmaster'),
  makeExamEntry('OK', 'headmaster'),
  makeExamEntry('OR', 'headmaster'),
  makeExamEntry('TN', 'headmaster'),
  makeExamEntry('UT', 'headmaster'),
  makeExamEntry('WI', 'headmaster'),
  makeExamEntry('WY', 'headmaster'),

  // ═══ PROMETRIC STATES (14) ═══
  makeExamEntry('FL', 'prometric'),
  makeExamEntry('TX', 'prometric'),
  makeExamEntry('NY', 'prometric'),
  makeExamEntry('AL', 'prometric'),
  makeExamEntry('CT', 'prometric'),
  makeExamEntry('DE', 'prometric'),
  makeExamEntry('HI', 'prometric'),
  makeExamEntry('ID', 'prometric'),
  makeExamEntry('LA', 'prometric'),
  makeExamEntry('NJ', 'prometric'),
  makeExamEntry('OK', 'prometric'),
  makeExamEntry('SD', 'prometric'),
  makeExamEntry('VT', 'prometric'),
  makeExamEntry('WV', 'prometric'),
];

export const PROVIDER_INFO = {
  credentia: {
    name: 'Credentia',
    color: '#2563eb',
  },
  prometric: {
    name: 'Prometric',
    color: '#059669',
  },
  headmaster: {
    name: 'Headmaster',
    color: '#7c3aed',
  },
  'state-specific': {
    name: 'State',
    color: '#6b7280',
  },
  other: {
    name: 'Other',
    color: '#6b7280',
  },
};

export const getExamById = (id) => {
  return EXAM_REGISTRY.find(exam => exam.id === id);
};

export const getExamsByProvider = (provider) => {
  return EXAM_REGISTRY.filter(exam => exam.provider === provider);
};

export const getUnlockedExams = () => {
  return EXAM_REGISTRY.filter(exam => exam.unlocked);
};

export default EXAM_REGISTRY;
